// 共用参数配置
export const commonParams = {
  version: 1.0
}



// WEBPACK FOOTER //
// ./src/common/js/config.js